// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type PromptListe } from "../../api";
import { useGetPromptsByAufgabeId as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function usePromptsByAufgabeIdQueryKey(aufgabeId: string): QueryKey {
  return ["api", "v1", "aufgaben", aufgabeId, "prompts"];
}

export function usePromptsByAufgabeId(
  aufgabeId: string,
  options: Omit<
    UseQueryOptions<PromptListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): PromptListe {
  const getter = useGetter();
  return useQuery(
    usePromptsByAufgabeIdQueryKey(aufgabeId),
    () => getter(aufgabeId),
    options
  ).data!;
}
